<button
    data-testid="downloadPresentation"
    type = "button"
    (click)="onDownloadPresentation()"
    [disabled]="disabled"
    class="neptune-button-blue hover:bg-neptune-color-primary-600 disabled:neptune-button-disabled"
    [ngClass]="name === 'Download Presentation' ? 'cursor-pointer neptune-button-blue hover:bg-neptune-color-primary-600' : 'neptune-button-disabled cursor-progress animate-pulse'">
    <img class="h-6 w-6" src="assets/shared-icons/neptune-download-icon.svg" alt="" aria-hidden="true" />
    {{name}}
</button>

<!-- Benchmark component overlay -->
<div class="benchmark-overlay" *ngIf="showBenchmark">
    <div class="benchmark-modal">
        <benchmark
            [title]="benchmarkTitle"
            [filters]="filters"
            (onClose)="onBenchmarkClose()"
            (onProceed)="onBenchmarkProceed($event)">
        </benchmark>
    </div>
</div>

<!-- Template and Translation selection overlay -->
<div class="template-translation-overlay neptune-modal-cover" *ngIf="showTemplateAndTranslationSelection">
    <div class="template-translation-modal w-[50vw] max-h-[90vh] px-12 py-7 bg-white flex flex-col p-4 rounded-lg">
        <presentation-options
            (onClose)="onTemplateAndTranslationClose()"
            (onProceed)="onTemplateAndTranslationProceed($event)"
            >
        </presentation-options>
    </div>
</div>
